import { render, staticRenderFns } from "./article_term.vue?vue&type=template&id=1850b8a6&scoped=true&"
import script from "./article_term.vue?vue&type=script&lang=js&"
export * from "./article_term.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1850b8a6",
  null
  
)

export default component.exports